module.exports = __webpack_public_path__ + "img/T11.5388d304.png";